/**
 * Normalises a raw user message for intent matching and context search.
 * Steps: lowercase → strip NFD combining marks → replace selected punctuation
 * with spaces while preserving decimal separators → collapse whitespace → trim.
 *
 * Used by both ChatbotService (intent matching) and ChatbotNavigationService
 * (substring matching against entity/agrupation names). Query text and stored
 * names pass through the same normalization before matching.
 */
export function normalizeChatbotText(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replaceAll(/[\u0300-\u036f]/g, '')
    .replaceAll(/[¿?¡!;:"'()]/g, ' ')
    // Keep decimal separators ("2,5 litros"); drop other dots/commas.
    .replaceAll(/(?<!\d)[.,]|[.,](?!\d)/g, ' ')
    .replaceAll(/\s+/g, ' ')
    .trim();
}
